export { GVCookiesLgpdAlert } from './gv-cookie-lgpd-alert';